export const SELECT_PLAYER = 'SELECT_PLAYER';
export const SET_PLAYER_FILTER = 'SET_PLAYER_FILTER';

export const GET_PLAYER_LIST = 'GET_PLAYER_LIST';
export const RECEIVED_PLAYER_LIST = 'RECEIVED_PLAYER_LIST';

export const GET_PLAYER_STATS = 'GET_PLAYER_STATS';
export const RECEIVED_PLAYER_STATS = 'RECEIVED_PLAYER_STATS';

export const GET_PLAYER_SHOTS = 'GET_PLAYER_SHOTS';
export const RECEIVED_PLAYER_SHOTS = 'RECEIVED_PLAYER_SHOTS';

export const SELECT_SHOT_TYPE = 'SELECT_SHOT_TYPE';
export const SELECT_SHOTS_FILTERED = 'SELECT_SHOTS_FILTERED';


// WEBPACK FOOTER //
// ./src/redux/actions/action-types.js